import { Col } from 'antd'
import React from 'react'
import { FaClock, FaLocationDot, FaRegBookmark } from 'react-icons/fa6'
import home from '../../../images/logo.png';
import {Variants, motion} from 'framer-motion'
import { Link, useLocation } from 'react-router-dom';
import ImageBox from '../../ImageBox';
import { useTranslation } from 'react-i18next';
import { ProductObject, useStore } from '../../../store/Store';
import { filterPrice, formatDate } from '../../Alert';
const cardVariants: Variants = {
    offscreen: {
      y: 50,
      opacity:0
    },
    onscreen: {
      y: 0,
      opacity:1,
      transition: {
        type: "easeOut",
        duration: 0.3
      }
    }
  };
  const cardVariantsOne: Variants = {
    offscreen: {
      y: 0,
      opacity:1
    },
    onscreen: {
      y: 0,
      opacity:1,
      transition: {
        type: "easeOut",
        duration: 0.3
      }
    }
  };
  interface MultipleSelectProps {
   data:ProductObject;number_key:number;
  }
  const CardHomeProduct: React.FC<MultipleSelectProps>=({data, number_key})=>{
  const {t}=useTranslation()
  const {money_type, setold_link}=useStore()
  let location = useLocation();
  return (
    <Col lg={24} md={24} sm={24}>
        <motion.div
    initial="offscreen"
    whileInView="onscreen"
    viewport={{ once: true, amount: 0.8 }}>
        <motion.div variants={number_key!==0?cardVariants:cardVariantsOne}>
        <Link  onClick={()=>{setold_link(location.search)}} to={"/product/home/product/"+data.id} className='card'>
            {/* <div className="lenta_card">
                <h1>TOP</h1>
            </div> */}
            <div className='card_img'>
            <ImageBox alt='image'  src={data.image!==null?data.image.image:home} />
            </div>
            <div className='card_text'>
                <div className='card_text_head'>
                <h1>{data.name!=null?data.name:''}</h1>
                <div className='card_price'>
                    <p>{money_type===2?filterPrice(data.price_usd)+" $":filterPrice(data.price_uzs)+t(t(" so'm"))}</p>
                    
                </div>
                </div>
                <div className='card_address'>
                    <div className='card_item'>
                        <span><FaLocationDot /></span>
                        <p>{data.region!=null?data.region[`name_${t("lang")==='ru'?'ru':'uz'}`]:''}, {data.district!=null?data.district[`name_${t("lang")==='ru'?'ru':'uz'}`]:''}</p>
                        </div>
                        
                    <div className='card_item card_time'>
                        <span><FaClock /></span>
                        <p>{formatDate(data.created_at)}</p>
                        </div>
                   
                </div>
                <div className='card_icon'><FaRegBookmark /></div>
            </div>
        </Link>
        </motion.div>
        </motion.div>
    </Col>
  )
}
export default CardHomeProduct